import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles(theme => ({
  appBar: {
    background: ({
      collapsed,
      background
    }) => collapsed ? 'transparent' : background || `linear-gradient(45deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
    boxShadow: props => props.collapsed ? theme.shadows[0] : theme.shadows[4],
    height: props => props.height,
    [theme.breakpoints.down('sm')]: {
      background: theme.palette.common.white
    }
  },
  toolbar: {
    background: 'transparent',
    display: 'flex',
    height: props => props.height,
    maxWidth: props => props.maxWidth,
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row-reverse'
    },
    [theme.breakpoints.down('xs')]: {
      background: theme.palette.common.white
    }
  }
}));